import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AuthCallback from './pages/AuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import LawyerDashboard from './pages/LawyerDashboard';
import ClientDashboard from './pages/ClientDashboard';
import CaseDetailPage from './pages/CaseDetailPage';
import DocumentsPage from './pages/DocumentsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import InvoicesPage from './pages/InvoicesPage';
import ReportsPage from './pages/ReportsPage';
import RemindersPage from './pages/RemindersPage';
import SendNotificationPage from './pages/SendNotificationPage';
import ActivityLogPage from './pages/ActivityLogPage';
import PaymentMethodsPage from './pages/PaymentMethodsPage';
import './App.css';

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously before rendering routes
  // This prevents race conditions with auth checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ForgotPasswordPage />} />
      <Route path="/dashboard" element={<AuthCallback />} />

      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/cases" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/cases/:caseId" element={<ProtectedRoute allowedRoles={['admin']}><CaseDetailPage /></ProtectedRoute>} />
      <Route path="/admin/documents" element={<ProtectedRoute allowedRoles={['admin']}><DocumentsPage /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/invoices" element={<ProtectedRoute allowedRoles={['admin']}><InvoicesPage /></ProtectedRoute>} />
      <Route path="/admin/reports" element={<ProtectedRoute allowedRoles={['admin']}><ReportsPage /></ProtectedRoute>} />
      <Route path="/admin/reminders" element={<ProtectedRoute allowedRoles={['admin']}><RemindersPage /></ProtectedRoute>} />
      <Route path="/admin/send-notification" element={<ProtectedRoute allowedRoles={['admin']}><SendNotificationPage /></ProtectedRoute>} />
      <Route path="/admin/activity-log" element={<ProtectedRoute allowedRoles={['admin']}><ActivityLogPage /></ProtectedRoute>} />
      <Route path="/admin/payment-methods" element={<ProtectedRoute allowedRoles={['admin']}><PaymentMethodsPage /></ProtectedRoute>} />

      {/* Lawyer Routes */}
      <Route path="/lawyer" element={<ProtectedRoute allowedRoles={['lawyer']}><LawyerDashboard /></ProtectedRoute>} />
      <Route path="/lawyer/cases" element={<ProtectedRoute allowedRoles={['lawyer']}><LawyerDashboard /></ProtectedRoute>} />
      <Route path="/lawyer/cases/:caseId" element={<ProtectedRoute allowedRoles={['lawyer']}><CaseDetailPage /></ProtectedRoute>} />
      <Route path="/lawyer/documents" element={<ProtectedRoute allowedRoles={['lawyer']}><DocumentsPage /></ProtectedRoute>} />
      <Route path="/lawyer/invoices" element={<ProtectedRoute allowedRoles={['lawyer']}><InvoicesPage /></ProtectedRoute>} />
      <Route path="/lawyer/reminders" element={<ProtectedRoute allowedRoles={['lawyer']}><RemindersPage /></ProtectedRoute>} />
      <Route path="/lawyer/send-notification" element={<ProtectedRoute allowedRoles={['lawyer']}><SendNotificationPage /></ProtectedRoute>} />

      {/* Client Routes */}
      <Route path="/client" element={<ProtectedRoute allowedRoles={['client']}><ClientDashboard /></ProtectedRoute>} />
      <Route path="/client/cases" element={<ProtectedRoute allowedRoles={['client']}><ClientDashboard /></ProtectedRoute>} />
      <Route path="/client/cases/:caseId" element={<ProtectedRoute allowedRoles={['client']}><CaseDetailPage /></ProtectedRoute>} />
      <Route path="/client/documents" element={<ProtectedRoute allowedRoles={['client']}><DocumentsPage /></ProtectedRoute>} />
      <Route path="/client/invoices" element={<ProtectedRoute allowedRoles={['client']}><InvoicesPage /></ProtectedRoute>} />
      <Route path="/client/reminders" element={<ProtectedRoute allowedRoles={['client']}><RemindersPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
